.exclusion-form {
  border-bottom: 1px solid var(--chart-101-pressed-dividers);
  padding: 0 calc(2 * var(--spacer));

  &--field {
    position: relative;
    display: inline-flex;
  }

  &--actions {
    margin-left: calc(1.5 * var(--spacer));
  }

  &--summary {
    position: relative;
    color: var(--chart-300-icon-buttons);
    font-size: var(--body-size-xsmall);
    margin-left: calc(1.5 * var(--spacer));
    padding-left: calc(1.5 * var(--spacer));

    span:not(:empty) {
      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 2px;
        height: 80%;
        width: 1px;
        background-color: var(--chart-101-pressed-dividers);
      }
    }
  }

  .tooltip {
    margin-left: var(--spacer);
    color: var(--chart-300-icon-buttons);
    top: 4px;
    font-size: 22px;
  }
}
